// extracted by mini-css-extract-plugin
export default {"tooltip":"CP-z","arrow":"DP-z"};